var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSad(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.0001 3.4C5.45959 3.4 3.4001 5.45949 3.4001 8C3.4001 10.5405 5.45959 12.6 8.0001 12.6C10.5406 12.6 12.6001 10.5405 12.6001 8C12.6001 5.45949 10.5406 3.4 8.0001 3.4ZM2.6001 8C2.6001 5.01766 5.01776 2.6 8.0001 2.6C10.9825 2.6 13.4001 5.01767 13.4001 8C13.4001 10.9824 10.9825 13.4 8.0001 13.4C5.01776 13.4 2.6001 10.9824 2.6001 8Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.28843 10.6004C8.5768 9.88878 7.42301 9.88878 6.71141 10.6004C6.5552 10.7566 6.30194 10.7566 6.14572 10.6004C5.98951 10.4442 5.98951 10.1909 6.14572 10.0347C7.16975 9.01067 8.83007 9.01067 9.85411 10.0347C10.0103 10.1909 10.0103 10.4442 9.85411 10.6004C9.6979 10.7566 9.44464 10.7566 9.28843 10.6004Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.53369 6.88889C5.53369 6.44706 5.89186 6.08889 6.33369 6.08889H6.33925C6.78108 6.08889 7.13925 6.44706 7.13925 6.88889C7.13925 7.33072 6.78108 7.68889 6.33925 7.68889H6.33369C5.89186 7.68889 5.53369 7.33072 5.53369 6.88889ZM8.86702 6.88889C8.86702 6.44706 9.2252 6.08889 9.66702 6.08889H9.67258C10.1144 6.08889 10.4726 6.44706 10.4726 6.88889C10.4726 7.33072 10.1144 7.68889 9.67258 7.68889H9.66702C9.2252 7.68889 8.86702 7.33072 8.86702 6.88889Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSad);
export default __webpack_public_path__ + "static/media/sad.f821384d3932ce5745af1e9199b3405c.svg";
export { ForwardRef as ReactComponent };